import { FAIcon, useTranslation, useSession } from '@nextgen-web-framework/all';
import { DisplayListTypePropTypes } from './types/propTypes';
import styles from './DisplayListType.module.scss';
export const DisplayListType = ({
  isPrivate = false,
  isDisplayOnMyShop = false,
  iconTheme,
  className = '',
  showListType = true,
  listCategory = '',
  categoryTextColor = '',
}: Readonly<DisplayListTypePropTypes>) => {
  const t = useTranslation();
  const { isABO, isMember } = useSession();
  const showListTypeBasedOnUser = isABO() || isMember();

  const getClassName = () => `${styles['list-type-icon']} ${iconTheme ? '' : styles['gray']}`;

  const categoryTextStyle = () => ({
    color: categoryTextColor,
  });

  return showListTypeBasedOnUser && showListType ? (
    <div className={`${styles['list-type-container']} ${className}`}>
      <span style={categoryTextStyle()}>
        <FAIcon iconName="tag" className={getClassName()} style={categoryTextStyle()} />
        {listCategory}
      </span>
      {isABO() && (
        <span style={categoryTextStyle()}>
          <FAIcon iconName={isPrivate ? 'eye-slash' : 'eye'} className={getClassName()} style={categoryTextStyle()} />{' '}
          {isPrivate ? t('cart.list.private') : t('cart.list.shareable')}
        </span>
      )}
      {isDisplayOnMyShop && (
        <span style={categoryTextStyle()}>
          <FAIcon iconName={'check'} className={getClassName()} style={categoryTextStyle()} />
          {t('cart.list.myShop')}
        </span>
      )}
    </div>
  ) : (
    <></>
  );
};
export { type DisplayListTypePropTypes };
